export default __webpack_public_path__ + "static/media/tiendaropa.c2592ae3.jpg";